import { ROLE_IDS } from "../../../constants/roles.ts"
import { RoutesPaths } from "../../../constants/routes.ts"
import type { UserInfo } from "../types/auth.types.ts"

// The add-email page accepts an invite on mount, which the account never chose.
const withoutInvite = (search: string) => {
  const params = new URLSearchParams(search)
  if (!params.has("invite")) return search
  params.delete("invite")
  const rest = params.toString()
  return rest ? `?${rest}` : ""
}

// `auth.isAdmin` is never set; the role is the only reliable signal.
export const isAdminAccount = (
  userInfo: Pick<UserInfo, "role"> | null | undefined
) => userInfo?.role?.name === "Admin"

/** Where a signed-in account belongs when no page was asked for. */
export const signedInLanding = (
  userInfo: Pick<UserInfo, "email_added" | "role"> | null | undefined,
  search = ""
) => {
  if (isAdminAccount(userInfo)) return RoutesPaths.home + search
  if (!userInfo?.email_added)
    return RoutesPaths.auth.addEmail + withoutInvite(search)

  const landing =
    userInfo.role?.id === ROLE_IDS.CUSTOMER
      ? RoutesPaths.portal.home
      : RoutesPaths.home
  return landing + search
}
